import { connect } from 'react-redux'
import * as action from '../../state/file-upload/action'
import * as customerAction from '../../state/detail/action'
import * as selector from '../../state/file-upload/selector'
import CustomerFileUpload from '../scan-file-upload/CustomerFileUpload'
import { FILE_TYPE_X_RAY } from '../../state/const'
import { CUSTOMER_XRAY_FILE_UPLOAD } from '../../ui-definition/customer-ui'
import * as customerSelector from "../../state/detail/selector";


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        customer: customerSelector.selectCustomer(state),
        fetching: selector.selectIsFetching(state, FILE_TYPE_X_RAY),
        fileType: FILE_TYPE_X_RAY,
        widgetId: CUSTOMER_XRAY_FILE_UPLOAD,
    }
}

const mapDispatchToProps = {
    uploadCustomerFile: action.uploadCustomerFile,
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/XRayFileUploadWidgetContainer.js